<template>
  <Form
    v-slot="{ handleSubmit, errors, validate }"
    :validation-schema="validationSchema"
    as="div"
    class="bg-white w-full"
  >
    <form @submit="handleSubmit($event, onSubmit(errors))">
      <div class="bg-white mx-auto mt-12" style="width: 920px">
        <div class="flex items-end justify-between">
          <div class="text-xl font-semibold leading-8 pt-2">
            {{ state._estimateData.service_category_name }}
          </div>
          <div class="text-base font-semibold">
            No : {{ state._estimateData.transaction_service_id }} -
            {{ state._estimateData.pattern_number }}
          </div>
        </div>
        <div class="pt-2">
          <Field
            as="input"
            type="text"
            name="title"
            id="title"
            class="block text-lg px-4 py-3 border rounded leading-4"
            :class="{
              'border-danger': state.isDirty.title && errors['title'],
            }"
            style="height: 40px; width: 430px"
            :maxlength="15"
            placeholder="タイトルを入力してください。（15文字以内）"
            v-model="state._estimateData.title"
            @blur="state.isDirty.title = true"
          />
          <ErrorMessage
            v-if="state.isDirty.title"
            name="title"
            as="span"
            class="text-danger text-xs leading-6"
          />
        </div>

        <section class="mt-8">
          <table class="w-full table-fixed divide-y divide-gray-12">
            <thead>
              <tr class="text-gray-62 leading-4 h-10">
                <td
                  class="text-center h-10 sticky top-0 z-10"
                  :class="{ is_sticky: state.onScroll }"
                  style="width: 312px"
                >
                  項目
                </td>
                <td
                  class="text-center h-10 sticky top-0 z-10"
                  :class="{ is_sticky: state.onScroll }"
                  style="width: 195px"
                >
                  数量
                </td>
                <td
                  class="text-center h-10 sticky top-0 z-10"
                  :class="{ is_sticky: state.onScroll }"
                  style="width: 155px"
                >
                  単価（円）
                </td>
                <td
                  class="text-center h-10 sticky top-0 z-10"
                  :class="{ is_sticky: state.onScroll }"
                  style="width: 136px"
                >
                  期間
                </td>
                <td
                  class="text-center h-10 sticky top-0 z-10"
                  :class="{ is_sticky: state.onScroll }"
                  style="width: 122px"
                >
                  小計（税抜）
                </td>
              </tr>
            </thead>

            <tbody
              v-for="(sectionItem, index) in state._estimateData.section_items"
              :key="index"
            >
              <tr class="bg-slate-300 h-12" style="border: solid 1px #dde1ed">
                <td class="pl-4 text-gray-92 font-semibold" colspan="4">
                  {{ sectionItem.name }}
                </td>
                <td
                  class="pr-4 text-right text-base text-gray-92 font-semibold"
                >
                  {{
                    state.subtotalCalculation[index].subtotal.toLocaleString()
                  }}
                </td>
              </tr>
              <tr
                v-for="(detailItem, idx) in sectionItem.detail_items"
                v-show="Object.keys(detailItem).length"
                :key="idx"
                :id="`${index}_${idx}`"
                :class="{
                  'bg-slate-50': state.hoverFlag === `${index}_${idx}`,
                }"
                style="height: 54px; border: solid 1px #dde1ed"
                class="relative"
                @mouseover="mouseOverAction(index, idx)"
                @mouseleave="mouseLeaveAction()"
              >
                <td
                  v-if="!state.editItem.includes(`${index}_${idx}`)"
                  class="pl-4"
                  :class="{
                    'cursor-pointer': state.hoverFlag === `${index}_${idx}`,
                  }"
                  style="border-right: solid 1px #dde1ed; width: 312px"
                  @click="editDetailItem(index, idx)"
                >
                  {{ detailItem.name }}
                  <img
                    v-if="state.hoverFlag === `${index}_${idx}`"
                    class="inline-flex"
                    style="width: 12.44px; height: 12.43px"
                    src="@/assets/icons/TransactionEstimatesIcon.svg"
                  />
                </td>
                <td
                  v-else-if="state.editItem.includes(`${index}_${idx}`)"
                  style="border-right: solid 1px #dde1ed; width: 312px"
                >
                  <Field
                    as="input"
                    type="text"
                    :name="`name${index}_${idx}`"
                    :id="`name${index}_${idx}`"
                    class="px-4 h-10"
                    style="width: 296px"
                    :style="{
                      backgroundColor: errors[`name${index}_${idx}`]
                        ? '#FFE9E9'
                        : '',
                    }"
                    placeholder="項目名を入力してください。"
                    v-model="detailItem.name"
                    @blur="noEditDetailItem(index, idx)"
                    @change="checkInputData(index, idx)"
                  />
                </td>
                <td
                  class="flex items-center"
                  style="
                    border-right: solid 1px #dde1ed;
                    width: 195px;
                    height: 54px;
                  "
                >
                  <Field
                    as="input"
                    type="number"
                    step="0.01"
                    :name="`quantity${index}_${idx}`"
                    :id="`quantity${index}_${idx}`"
                    class="px-4 ml-4 mr-2 text-right text-base border rounded w-20 h-10"
                    :style="{
                      backgroundColor: errors[`quantity${index}_${idx}`]
                        ? '#FFE9E9'
                        : '',
                    }"
                    v-model.number="detailItem.quantity"
                    placeholder="0"
                    @change="
                      checkInputData(index, idx);
                      formatCurrencyQuantity(index, idx);
                    "
                  />
                  <div
                    class="selectbox"
                    :class="{
                      'bg-slate-50': state.hoverFlag === `${index}_${idx}`,
                    }"
                    @mouseleave="state.toggleOptionSelect = false"
                  >
                    <span
                      class="selectbox-box inline-flex"
                      @click="openSelectbox('quantityUnit', index, idx)"
                    >
                      <span
                        class="text-xs text-gray-92"
                        v-for="unit in sectionItem.quantity_units"
                        v-show="unit.id == detailItem.est_quantity_unit_id"
                        :key="unit.id"
                        >{{ unit.name }}</span
                      >
                    </span>
                    <div
                      class="selectbox-selector"
                      v-show="
                        state.toggleOptionSelect ===
                        `quantityUnit${index}_${idx}`
                      "
                    >
                      <div
                        class="selectbox-selector-option text-xs text-gray-92"
                        :class="{
                          active: detailItem.est_quantity_unit_id == option.id,
                        }"
                        v-for="option in sectionItem.quantity_units"
                        :key="'optionId' + option.id"
                        @click="
                          state.toggleOptionSelect = false;
                          detailItem.est_quantity_unit_id = option.id;
                        "
                      >
                        {{ option.name }}
                      </div>
                    </div>
                    <Field
                      as="select"
                      class="hidden"
                      :name="`quantityUnit${index}_${idx}`"
                      v-model="detailItem.est_quantity_unit_id"
                    >
                      <option
                        v-for="option in sectionItem.quantity_units"
                        :value="option.id"
                        :key="'hiddenOption' + option.id"
                      />
                    </Field>
                  </div>
                </td>
                <td style="border-right: solid 1px #dde1ed; width: 155px">
                  <Field
                    as="input"
                    type="number"
                    step="0.01"
                    :name="`price${index}_${idx}`"
                    :id="'price' + `${index}_${idx}`"
                    :style="{
                      backgroundColor: errors[`price${index}_${idx}`]
                        ? '#FFE9E9'
                        : '',
                    }"
                    class="ml-4 px-4 text-right text-base border rounded h-10"
                    style="width: 123px"
                    v-model.number="detailItem.price"
                    placeholder="10,000"
                    @change="
                      checkInputData(index, idx);
                      formatCurrencyPrice(index, idx);
                    "
                  />
                </td>
                <td
                  class="flex items-center"
                  style="
                    border-right: solid 1px #dde1ed;
                    width: 134px;
                    height: 54px;
                  "
                  :class="{ 'bg-slate-50': !sectionItem.term_units.length }"
                >
                  <Field
                    as="input"
                    type="number"
                    :name="`term${index}_${idx}`"
                    :id="`term${index}_${idx}`"
                    class="ml-4 mr-2 px-4 text-right text-base border rounded h-10"
                    style="width: 59px"
                    :style="{
                      backgroundColor: errors[`term${index}_${idx}`]
                        ? '#FFE9E9'
                        : '',
                    }"
                    v-model.number="detailItem.term"
                    @change="
                      checkInputData(index, idx);
                      formatCurrencyTerm(index, idx);
                    "
                    :disabled="!sectionItem.term_units.length"
                  />
                  <div
                    v-if="sectionItem.term_units.length"
                    class="selectbox"
                    :class="{
                      'bg-slate-50': state.hoverFlag === `${index}_${idx}`,
                    }"
                    @mouseleave="state.toggleOptionSelect = false"
                  >
                    <span
                      class="selectbox-box inline-flex"
                      @click="openSelectbox('termUnit', index, idx)"
                    >
                      <span
                        class="text-xs text-gray-92"
                        v-for="term in sectionItem.term_units"
                        v-show="term.id == detailItem.est_term_unit_id"
                        :key="'termUnitId' + term.id"
                        >{{ term.name }}</span
                      >
                    </span>
                    <div
                      class="selectbox-selector"
                      v-show="
                        state.toggleOptionSelect === `termUnit${index}_${idx}`
                      "
                    >
                      <div
                        class="selectbox-selector-option text-xs text-gray-92"
                        :class="{
                          active: detailItem.est_term_unit_id == option.id,
                        }"
                        v-for="option in sectionItem.term_units"
                        :key="'optionId' + option.id"
                        @click="
                          state.toggleOptionSelect = false;
                          detailItem.est_term_unit_id = option.id;
                        "
                      >
                        {{ option.name }}
                      </div>
                    </div>
                    <Field
                      as="select"
                      class="hidden"
                      :name="`termUnit${index}_${idx}`"
                      v-model="detailItem.est_term_unit_id"
                    >
                      <option
                        v-for="option in sectionItem.term_units"
                        :value="option.id"
                        :key="'hiddenOption' + option.id"
                      />
                    </Field>
                  </div>
                  <div v-else>
                    <span class="selectbox-box inline-flex"> </span>
                    <div class="selectbox-selector"></div>
                  </div>
                </td>
                <td
                  v-if="Object.keys(detailItem).length"
                  class="relative bg-slate-50 text-base text-gray-62 text-right pr-4"
                  style="width: 122px"
                >
                  {{
                    state.subtotalCalculation[index].items[idx].toLocaleString()
                  }}
                  <img
                    @click="deleteDetailItem(index, idx)"
                    v-if="state.hoverFlag === `${index}_${idx}`"
                    class="absolute p-1 bg-white w-8 h-8 rounded cursor-pointer"
                    style="
                      box-shadow: 0px 0px 4px rgba(152, 163, 190, 0.6);
                      left: 114px;
                      bottom: 10px;
                    "
                    src="@/assets/icons/Trash1.18.svg"
                  />
                </td>
              </tr>

              <tr>
                <td class="pt-3 pb-6">
                  <div
                    class="inline-flex items-center cursor-pointer"
                    @click="createDetailItem(index)"
                  >
                    <img
                      class="mr-2"
                      style="width: 10px"
                      src="@/assets/icons/Plus.svg"
                    />
                    <a
                      class="text-gray-92"
                      style="border-bottom: solid 1px #dde1ed"
                      >項目を追加</a
                    >
                  </div>
                </td>
              </tr>

              <tr>
                <td class="pb-4">
                  <div v-for="error of Object.entries(errors)" :key="error">
                    <span
                      v-if="error[0].indexOf(index + '_') !== -1"
                      class="block text-danger text-xs leading-6"
                      >{{ error[1] }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr>
                <td style="padding-bottom: 36px" colspan="5">
                  <CompEstimateNoteParts
                    :sectionItem="sectionItem"
                    :index="index"
                    @update-tmp-data="updateTmpData"
                  ></CompEstimateNoteParts>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <div
          class="flex flex-col divide-y divide-gray-12 ml-auto"
          style="width: 400px; margin-top: 58px; padding-bottom: 50px"
        >
          <div class="flex flex-row px-2 py-3 justify-between leading-8">
            <div class="text-gray-92 font-semibold">小計（税別）</div>
            <div>
              <span class="text-black text-lg">{{
                state.totalCalculation.subtotal.toLocaleString()
              }}</span>
              <span class="ml-1 leadning-4 text-gray-92 text-xs">円</span>
            </div>
          </div>
          <div class="flex flex-row px-2 py-3 justify-between leading-8">
            <div class="text-gray-92 font-semibold">
              消費税（{{ state._estimateData.tax_rate }}%)
            </div>
            <div>
              <span class="text-black text-lg">{{
                state.totalCalculation.tax.toLocaleString()
              }}</span>
              <span class="ml-1 leadning-4 text-gray-92 text-xs">円</span>
            </div>
          </div>
          <div class="flex flex-row px-2 py-3 justify-between leading-8">
            <div class="text-gray-92 font-semibold">合計（税込）</div>
            <div>
              <span class="text-black text-2xl font-semibold">{{
                state.totalCalculation.total.toLocaleString()
              }}</span>
              <span class="ml-1 leadning-4 text-gray-92 text-sm">円</span>
            </div>
          </div>
          <span class="text-xs text-gray-92 text-right pt-6"
            >※一括見積もりの概算であり、金額を確定するものではありません。</span
          >
        </div>

        <div
          v-if="
            state._estimateData.questions &&
            state._estimateData.questions.length > 0
          "
          class="border-t border-gray-12 mt-2 mb-16"
        >
          <div class="flex items-baseline mt-8">
            <div class="font-semibold">質問リスト</div>
            <span
              class="ml-2 text-coral-main font-semibold"
              style="font-size: 11px"
              >必須</span
            >
          </div>
          <div class="mt-3 mb-8">
            カスタマー様より下記の質問が届いています。回答をご記入ください。
          </div>
          <div
            v-for="question in state._estimateData.questions"
            :key="question.id"
            class="mb-6"
          >
            <div class="flex mb-3">
              <div
                style="min-width: 20px; height: 20px"
                class="flex items-center justify-center rounded-full bg-slate-300"
              >
                <img src="@/assets/icons/AlphabetQ.svg" />
              </div>
              <div class="ml-3 font-semibold whitespace-pre-wrap">
                {{ question.name }}
              </div>
            </div>
            <div class="flex items-center">
              <div
                style="
                  min-width: 20px;
                  height: 20px;
                  background-color: rgba(108, 126, 206, 0.1);
                "
                class="flex items-center justify-center rounded-full"
              >
                <img src="@/assets/icons/AlphabetA.svg" />
              </div>
              <Field
                as="textarea"
                :name="`question${question.id}`"
                :id="`question${question.id}`"
                class="block ml-3 px-4 py-3 border rounded resize-none"
                :class="{
                  'border-danger': errors[`question${question.id}`],
                }"
                style="width: 920px; line-height: 18px; overflow: auto"
                :style="{
                  height: `${state.getTextareaHeight(question.value)}px`,
                }"
                placeholder="この質問に対する回答を入力してください"
                v-model="question.value"
              />
            </div>
            <ErrorMessage
              :name="`question${question.id}`"
              as="span"
              class="block text-danger text-xs leading-6 ml-8"
            />
          </div>
        </div>

        <div class="mb-20">
          <div class="inline-block mb-2">
            <label for="message" class="text-gray-92 font-semibold leading-4"
              >メッセージ入力</label
            >
            <span
              class="ml-2 text-coral-main font-semibold"
              style="font-size: 11px"
              >必須</span
            >
            <div class="my-2">
              カスタマー様へメッセージとして送信されます。見積書と共に提案書・参考資料などがあれば添付してください。
            </div>
          </div>
          <Field
            as="textarea"
            name="message"
            id="message"
            class="block px-4 py-3 min-w-full border rounded resize-none"
            :class="{
              'border-danger': state.isDirty.message && errors.message,
            }"
            style="line-height: 18px; overflow: auto; min-height: 112px"
            :style="{ height: `${state.getMessageTextareaHeight()}px` }"
            placeholder="※ご挨拶、見積書の御礼、今回の提案の補足などご記入ください。"
            v-model="state._estimateData.message"
            @blur="state.isDirty.message = true"
          />
          <ErrorMessage
            v-if="state.isDirty.message"
            name="message"
            as="span"
            class="block text-danger text-xs leading-6"
          />
          <div>
            <div
              v-for="(file, index) in state._estimateData.files"
              :key="index"
              class="m-3 flex justify-end"
            >
              <a
                v-if="file.id && file.url"
                target="_blank"
                :href="file.url"
                class="ml-2 text-coral-main"
              >
                {{ file.name }}
              </a>
              <div v-else class="ml-2 text-coral-main">{{ file.name }}</div>
              <span
                class="ml-4 cursor-pointer"
                @click="state._estimateData.files.splice(index, 1)"
              >
                <span class="text-gray-92 text-xs border-b hover:button"
                  >ファイルを削除</span
                >
              </span>
            </div>
            <div class="mt-4">
              <div>
                <label
                  for="attached_file"
                  class="flex text-gray-92 text-xs rounded-full ml-auto px-5 py-2 mb-2 cursor-pointer text-center leading-none font-semibold border border-gray-32 hover:button"
                  style="width: 96px; height: 36px"
                >
                  <img
                    style="width: 18px; height: 18px"
                    src="@/assets/icons/Clip.svg"
                  />
                  <div style="padding: 3px 0 0 7px">添付</div>
                </label>
                <input
                  id="attached_file"
                  name="attached_file"
                  type="file"
                  @change.prevent="selectedAttachedFile($event)"
                  style="display: none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="bg-white"
        style="box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3); z-index: 20"
      >
        <div class="flex justify-between h-16 mx-auto" style="width: 1000px">
          <div class="flex items-center">
            <div class="flex items-baseline">
              <span class="ml-10 mr-4 text-gray-92 font-semibold">合計</span>
              <span class="text-black text-2xl font-semibold mr-1">{{
                state.totalCalculation.total.toLocaleString()
              }}</span>
              <span class="text-gray-92 font-semibold">円（税込）</span>
            </div>
          </div>
          <div class="flex">
            <button
              type="submit"
              @click="validate"
              class="flex items-center justify-center text-base text-white font-semibold hover:button focus:outline-none"
              :class="[state.processingFlag ? 'bg-slate-300' : 'bg-coral-main']"
              style="width: 240px"
              :disabled="state.processingFlag"
            >
              内容を確認
            </button>
          </div>
        </div>
      </div>
    </form>
  </Form>
</template>

<script>
import { reactive, computed, inject, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Form, Field, ErrorMessage } from 'vee-validate';
import axios from '@/utils/axiosAuth.js';
import CompEstimateNoteParts from '@/views/estimate/vue/CompEstimateNoteParts.vue';

export default {
  props: {
    transactionId: String,
    patternNumber: String,
    estimateData: Object,
    subtotal: Array,
    total: Object,
    validationSchema: Object,
  },
  components: {
    CompEstimateNoteParts,
    Form,
    Field,
    ErrorMessage,
  },
  setup(props, context) {
    const globalMethods = inject('globalMethods');
    const router = useRouter();

    const state = reactive({
      editItem: [],
      hoverFlag: -1,
      onScroll: false,
      toggleOptionSelect: false,
      timerService: null,
      processingFlag: false,
      isDraftedDisplay: 1,
      isDirty: {
        title: false,
        message: false,
      },
      _subtotal: computed(() => {
        return props.subtotal;
      }),
      _estimateData: computed(() => {
        return props.estimateData;
      }),
      subtotalCalculation: computed(() => {
        if (
          !props.estimateData.section_items ||
          !Array.isArray(props.estimateData.section_items)
        ) {
          return [];
        }
        let subtotal = [];
        for (let i = 0; i < props.estimateData.section_items.length; i++) {
          subtotal[i] = {
            subtotal: 0,
            items: [],
          };

          for (
            let j = 0;
            j < props.estimateData.section_items[i].detail_items.length;
            j++
          ) {
            if (
              Object.keys(props.estimateData.section_items[i].detail_items[j])
                .length
            ) {
              let term = 1;
              if (props.estimateData.section_items[i].detail_items[j].term) {
                term = props.estimateData.section_items[i].detail_items[j].term;
              }
              subtotal[i].items[j] =
                props.estimateData.section_items[i].detail_items[j].quantity *
                props.estimateData.section_items[i].detail_items[j].price *
                term *
                checkQuantityRatio(i, j);
              subtotal[i].items[j] = Math.floor(subtotal[i].items[j]);
              subtotal[i].subtotal += subtotal[i].items[j];
            }
          }
          state._subtotal[i] = subtotal[i];
        }
        return subtotal;
      }),
      totalCalculation: computed(() => {
        let total = {
          subtotal: 0,
          tax: 0,
          total: 0,
        };
        for (let i = 0; i < state.subtotalCalculation.length; i++) {
          total.subtotal += state.subtotalCalculation[i].subtotal;
          total.tax = Math.floor(
            (total.subtotal * state._estimateData.tax_rate) / 100
          );
          total.total = total.subtotal + total.tax;
        }
        Object.assign(props.total, total);
        return total;
      }),
      getTextareaHeight: computed(() => {
        return function (value) {
          let rowCount = `${value}\n`.match(/\n/g).length;
          const LINEHEIGHT = 40;
          let lineHeight = LINEHEIGHT + (rowCount - 1) * 18;
          return lineHeight;
        };
      }),
      getMessageTextareaHeight: computed(() => {
        return function () {
          let rowCount = `${state._estimateData.message}\n`.match(/\n/g).length;
          const LINEHEIGHT = 40;
          let lineHeight = LINEHEIGHT + (rowCount - 1) * 18;
          return lineHeight;
        };
      }),
      countDetailItem: computed(() => {
        if (!state._estimateData.section_items) {
          return;
        }
        let count = 0;
        for (const sectionItem of state._estimateData.section_items) {
          for (const detailItem of sectionItem.detail_items) {
            if (Object.keys(detailItem).length) {
              count++;
            }
          }
        }
        if (count === 0) {
          return false;
        }
        return true;
      }),
      canUpdateFlag: computed(() => {
        if (
          state.isDraftedDisplay ||
          state.totalCalculation.subtotal < 0 ||
          state.processingFlag
        ) {
          return false;
        }
        return true;
      }),
    });

    // 添付ファイル選択
    const selectedAttachedFile = async (e = null) => {
      if (e === null) {
        return;
      }
      const files = e.target.files;
      if (files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          let attachedFile = {
            name: files[0].name,
            content: reader.result,
          };
          state._estimateData.files.push(attachedFile);
          document.getElementById('attached_file').value = ''; // 同じファイルを選択可能にする
        };
        return;
      }
    };

    function checkQuantityRatio(index, idx) {
      let quantityRatio = 1;
      for (let quantityUnit of state._estimateData.section_items[index]
        .quantity_units) {
        if (
          quantityUnit.id ===
            state._estimateData.section_items[index].detail_items[idx]
              .est_quantity_unit_id &&
          quantityUnit.identifier === 'percent'
        ) {
          quantityRatio = 0.01;
        }
      }
      return quantityRatio;
    }

    function formatCurrencyQuantity(index, idx) {
      if (
        state._estimateData.section_items[index].detail_items[idx].quantity ===
        ''
      ) {
        return;
      }
      return (state._estimateData.section_items[index].detail_items[
        idx
      ].quantity =
        Math.floor(
          state._estimateData.section_items[index].detail_items[idx].quantity *
            Math.pow(10, 2)
        ) / Math.pow(10, 2));
    }

    function formatCurrencyPrice(index, idx) {
      if (
        state._estimateData.section_items[index].detail_items[idx].price === ''
      ) {
        return;
      }
      return (state._estimateData.section_items[index].detail_items[idx].price =
        Math.floor(
          state._estimateData.section_items[index].detail_items[idx].price *
            Math.pow(10, 2)
        ) / Math.pow(10, 2));
    }

    function formatCurrencyTerm(index, idx) {
      if (
        state._estimateData.section_items[index].detail_items[idx].term === ''
      ) {
        return;
      }
      return (state._estimateData.section_items[index].detail_items[idx].term =
        Math.floor(
          state._estimateData.section_items[index].detail_items[idx].term
        ));
    }

    function mouseOverAction(index, idx) {
      if (!state._estimateData.section_items[index].detail_items[idx].id) {
        state.hoverFlag = `${index}_${idx}`;
      }
    }

    function mouseLeaveAction() {
      state.hoverFlag = -1;
    }

    function openSelectbox(name, index, idx) {
      if (state.toggleOptionSelect) {
        state.toggleOptionSelect = false;
        return;
      }
      state.toggleOptionSelect = name + `${index}_${idx}`;
    }

    function editDetailItem(index, idx) {
      if (!state._estimateData.section_items[index].detail_items[idx].id) {
        state.editItem.push(`${index}_${idx}`);
      }
    }

    function noEditDetailItem(index, idx) {
      let itemName =
        state._estimateData.section_items[index].detail_items[idx].name;
      if (!itemName || (typeof itemName == 'string' && !itemName.trim())) {
        return;
      }
      let filterItems = state.editItem.filter((n) => n !== `${index}_${idx}`);
      state.editItem = filterItems;
    }

    function createDetailItem(index) {
      let sectionItem = state._estimateData.section_items;
      sectionItem[index].detail_items.push({
        id: null,
        name: null,
        value_id: null,
        quantity: null,
        price: null,
        term: null,
        amount: null,
        est_quantity_unit_id: sectionItem[index].quantity_units[0].id,
        est_term_unit_id: sectionItem[index].term_units.length
          ? sectionItem[index].term_units[0].id
          : null,
        quantity_unit_name: sectionItem[index].quantity_units[0].name,
        term_unit_name: sectionItem[index].term_units.length
          ? sectionItem[index].term_units[0].name
          : null,
      });
      editDetailItem(index, sectionItem[index].detail_items.length - 1);
      context.emit('make-validationschema');
    }

    function deleteDetailItem(index, idx) {
      state._estimateData.section_items[index].detail_items[idx] = {};
      delete props.validationSchema[`name${index}_${idx}`];
      delete props.validationSchema[`quantity${index}_${idx}`];
      delete props.validationSchema[`price${index}_${idx}`];

      if (!state.isDraftedDisplay) {
        if (state.timerService) {
          clearTimeout(state.timerService);
        }
        state.timerService = setTimeout(updateTmpData, 3000);
      }
    }

    function checkInputData(index, idx) {
      if (
        state._estimateData.section_items[index].detail_items[idx].name &&
        typeof state._estimateData.section_items[index].detail_items[idx]
          .name == 'string' &&
        state._estimateData.section_items[index].detail_items[
          idx
        ].name.trim() &&
        Number.isFinite(
          state._estimateData.section_items[index].detail_items[idx].price
        ) &&
        Number.isFinite(
          state._estimateData.section_items[index].detail_items[idx].quantity
        )
      ) {
        if (!state.isDraftedDisplay) {
          if (state.timerService) {
            clearTimeout(state.timerService);
          }
          state.timerService = setTimeout(updateTmpData, 3000);
        }
      }
      return;
    }

    async function updateTmpData() {
      if (!state.canUpdateFlag) {
        return;
      }
      state.processingFlag = true;

      const postData = makePostData();

      await axios
        .post(
          `transactions/${props.transactionId}/est/update/${props.patternNumber}`,
          postData
        )
        .then((res) => {
          let response = res.data.data;
          Object.assign(state._estimateData.files, res.data.data.files);
          for (const [index, sectionItem] of Object.entries(
            response.section_items
          )) {
            for (const [idx, detailItem] of Object.entries(
              sectionItem.detail_items
            )) {
              if (
                Object.keys(
                  state._estimateData.section_items[index].detail_items[idx]
                ).length &&
                !state._estimateData.section_items[index].detail_items[idx]
                  .value_id
              ) {
                state._estimateData.section_items[index].detail_items[
                  idx
                ].value_id = detailItem.value_id;
              }
            }
          }
          state.processingFlag = false;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
          state.processingFlag = false;
        });
    }

    async function onSubmit(errors) {
      state.isDirty.title = true;
      state.isDirty.message = true;
      if (!state.canUpdateFlag) {
        return;
      }

      onScrollTo(Object.keys(errors)[0]);
      if (Object.keys(errors).length) {
        return;
      }

      if (!state.countDetailItem) {
        return;
      }

      if (state.timerService) {
        clearTimeout(state.timerService);
      }

      state.processingFlag = true;

      const postData = makePostData();

      postData.confirm_flag = 1;

      await axios
        .post(
          `transactions/${props.transactionId}/est/update/${props.patternNumber}`,
          postData
        )
        .then((res) => {
          Object.assign(state._estimateData, res.data.data);
          router.push({
            name: 'EstimateConfirm',
            params: {
              transactionId: props.transactionId,
              patternNumber: props.patternNumber,
            },
          });
          window.scrollTo(0, 0);
          state.processingFlag = false;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
          state.processingFlag = false;
        });
    }

    function makePostData() {
      let postData = {
        title: state._estimateData.title,
        section_items: [],
        message: state._estimateData.message,
        files: [],
        questions: [],
      };

      for (let i = 0; i < state._estimateData.section_items.length; i++) {
        let obj = {
          detail_items: [],
          value_id: state._estimateData.section_items[i].value_id,
          id: state._estimateData.section_items[i].id,
          note: state._estimateData.section_items[i].note,
        };

        for (
          let s = 0;
          s < state._estimateData.section_items[i].detail_items.length;
          s++
        ) {
          if (
            state._estimateData.section_items[i].detail_items[s].name &&
            Object.keys(state._estimateData.section_items[i].detail_items[s])
              .length
          ) {
            obj.detail_items.push(
              state._estimateData.section_items[i].detail_items[s]
            );
          }
        }
        postData.section_items.push(obj);
      }

      // 添付ファイル
      for (const file of state._estimateData.files) {
        postData.files.push(file);
      }

      // 質問リスト
      for (const question of state._estimateData.questions) {
        postData.questions.push(question);
      }

      return postData;
    }

    function onScrollTo(id) {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }

    onMounted(async () => {
      await axios
        .get('/sellers')
        .then((response) => {
          state.isDraftedDisplay = response.data.data[0].is_drafted_display;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });

      window.addEventListener('scroll', function () {
        if (window.scrollY >= 225) {
          state.onScroll = true;
        } else if (window.scrollY < 225) {
          state.onScroll = false;
        }
      });
    });

    return {
      state,
      selectedAttachedFile,
      formatCurrencyQuantity,
      formatCurrencyPrice,
      formatCurrencyTerm,
      mouseOverAction,
      mouseLeaveAction,
      openSelectbox,
      editDetailItem,
      noEditDetailItem,
      createDetailItem,
      deleteDetailItem,
      checkInputData,
      updateTmpData,
      onSubmit,
      onScrollTo,
    };
  },
};
</script>

<style lang="scss" scoped>
.is_sticky {
  box-sizing: border-box;
  @apply text-gray-92 border-b border-gray-12;
  background: #f1f2f6;
}
input {
  outline: none;
  &:focus {
    border: 1px solid #2cb2b2;
    box-sizing: border-box;
    box-shadow: 0px 0px 0px 2px rgba(73, 168, 174, 0.2);
    border-radius: 4px;
  }
}
textarea {
  outline: none;
  &:focus {
    border: 1px solid #2cb2b2;
    box-sizing: border-box;
    box-shadow: 0px 0px 0px 2px rgba(73, 168, 174, 0.2);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #dde1ed;
    border-radius: 10px;
  }
}
.selectbox {
  position: relative;
  height: 22px;
  width: 100%;
  margin-top: 4px;
  &-box {
    border-bottom-width: 1px;
    border-style: dashed;
    border-color: #dde1ed;
    cursor: pointer;
    &:after {
      content: '';
      width: 11px;
      height: 11px;
      border: 5.5px solid transparent;
      border-top: 5.5px solid rgba(6, 16, 26, 0.92); // border-gray-92
      box-sizing: border-box;
      margin-top: 8px;
      margin-left: 4px;
    }
  }
  &-selector {
    position: absolute;
    top: 22px;
    left: 0;
    padding: 3px 0px;
    background: #fff;
    max-height: 356px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3);
    overflow-y: scroll;
    z-index: 20;
    cursor: pointer;
  }
  &-selector-option {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @apply text-gray-62;
    box-sizing: border-box;
    padding: 0px 6px;
    min-height: 22px;
    &.active {
      @apply text-gray-92;
    }
    &:hover {
      @apply text-gray-92;
      background: #f1f2f6;
    }
  }
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
